/**
 * Extrae los datos data-* del elemento que contiene la tabla o enlace dentro de la tabla
 * @param {Object} $elem Selector Jquery
 * @return {{search: *, qty: *, id: *, type: *, url: *}}
 * @private
 */
export const _extractDOMElemData = ($elem) => {
    return {
        'url': $elem.data('url'),
        'type'   : $elem.data('elementtype'),
        'id'     : $elem.data('elementid'),
        'search' : $elem.data('searchtype'),
        'qty'    : $elem.data('searchqty')
    };
};

/**
 * Cambia el botón de Ver más, acorde al mercado seleccionado en el tab
 * @param {object} $btn Selector JQuery del botón
 * @param {object} params Parámetros como el nombre del mercado/índice o la nueva URL de destino
 */
export const updateLinkViewMore = ($btn, params) =>
{
    var tradingText = '';
    if (params.url.includes('zona-de-trading')) tradingText = ' Zona de Trading ';
    $btn.prop('title', 'Ir a ' + tradingText + params.name);
    $btn.prop('href', params.url);
    $btn.text('Ir a ' + tradingText + params.name);
};

/**
 * Fuerza la actualización de la pestaña activa
 * @param $tab
 */
export const updateTabSelection = ($tab) =>
{
    $tab.siblings().removeClass('active');
    $tab.addClass('active');
};

/**
 * Código extraído de la versión anterior de Soportes y Resistencias tal cual se encontró
 * Genera el HTML de la td de la alerta, el datetime y el time de la rotura de soporte/resistencia
 * @param {number} alert 1 si es una resistencia o 2 si es un soporte
 * @param {number, String} timestamp marca unix de cúando se produjo la rotura
 * @return {array} Con el código html de la fila intermedia, el datetime y el time
 */
export const suppresResult = (alert, timestamp) => {
    //Determinar el HTML a mostrar: resistencia o soporte
    let html;
    if(alert === 1 || alert === '1'){
        html = '<span class="highGreen">Resistencia  <i class="icon-up"></i></span>';
    }else if(alert === 2 || alert === '2'){
        html = '<span class="highRed">Soporte  <i class="icon-down"></i></span>';
    }else return null;

    const date = new Date(0);
    date.setUTCMilliseconds(timestamp * 1000);
    const nowDate = new Date();

    let time = '';
    let dateTime = '';
    time = ('0' + date.getHours()).slice(-2);
    time += ":" + ('0' + date.getMinutes()).slice(-2);
    dateTime = ('0' + date.getDate()).slice(-2);
    dateTime += "/" + ('0' + (date.getMonth() + 1)).slice(-2);
    dateTime += "/" + date.getFullYear();

    if (date.toDateString() === nowDate.toDateString()) {
        // trDate = '<td title="' + dateTime + '">' + time + '</td>';
        return [html, dateTime, time];
    } else {
        // trDate = '<td title="' + time + '">' + dateTime + '</td>';
        return [html, time, dateTime];
    }
};

export const LOADER_HTML = '<div class="bigLoader"><div class="loader"></div></div>';